var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"text"},[_c('p',[_vm._v("文字內容｜廖婉馨、詹雅涵"),_c('br'),_vm._v(" 視覺設計｜蔡詠全"),_c('br'),_vm._v(" 網頁設計｜黃莘懿"),_c('br'),_vm._v(" 特別感謝｜台北地方異聞工作室"),_c('br'),_vm._v("     ｜奇異果文創"),_c('br'),_vm._v("     ｜晨星出版社 ")])])])
}]

export { render, staticRenderFns }